// extracted by mini-css-extract-plugin
export var btn = "Button-module--btn--e233c";
export var disabled = "Button-module--disabled--448e5";
export var icon = "Button-module--icon--78e9d";
export var iconOnly = "Button-module--iconOnly--7c169";
export var inner = "Button-module--inner--446ab";
export var large = "Button-module--large--b4d29";
export var small = "Button-module--small--748e8";